import React from "react";

import { MidPoint } from "../../types";
import { getActionPath } from "../../utils";
import styles from "./free-draw-preview.module.scss";

export interface FreeDrawPreviewProps {
  smoothFreeDrawPoints: MidPoint[];
  freeDrawPoints: MidPoint[];
}

export const FreeDrawPreview = ({ smoothFreeDrawPoints, freeDrawPoints }: FreeDrawPreviewProps) => {
  const pos = smoothFreeDrawPoints[0] as MidPoint;
  const endPos = smoothFreeDrawPoints[smoothFreeDrawPoints.length - 1] as MidPoint;
  const midPoints = smoothFreeDrawPoints.slice(1, -1);
  const pathData = getActionPath({ pos, midPoints, endPos });
  const tracePathData = getActionPath({
    pos: freeDrawPoints[0] as MidPoint,
    midPoints: freeDrawPoints.slice(1),
    endPos: freeDrawPoints[freeDrawPoints.length - 1] as MidPoint,
  });
  return (
    <>
      <path className={styles.cutLine} d={pathData} />
      <path className={styles.trace} d={tracePathData} />
    </>
  );
};
